import http from '@gp/utils/httpTS';
import { WorkbenchListType, RemindHistoryType, RemindHoverInfoType, GateReviewUpdateType, FetchIsGRExistsParamsType } from '@gp/types/gateReview.d';

// 工作台表格数据
export const getWorkbenchList = (params: WorkbenchListType) => {
  return http.post('/api/v1/globalpedia_pc/pr/workbench/list', params);
};

// 获取催办弹窗内的相关信息
export const queryRemindHistory = (params: RemindHistoryType) => {
  return http.get('/api/v1/globalpedia_pc/pr/remind/history', {params});
};

// 获取催办下来选择中Done的hover提示内容
export const queryRemindInfo = (params: RemindHoverInfoType) => {
  return http.get('/api/v1/globalpedia_pc/pr/remind/info', {params});
};
